import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MobileStickyCTA() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const onHome = pathname === "/";
    const [show, setShow] = useState(!onHome); // legal pages: show right away

    useEffect(() => {
        if (!onHome) { setShow(true); return; }

        const heroSentinel = document.querySelector("#hero-end-sentinel");
        const formEl = document.querySelector("#enquiry-form");
        if (!heroSentinel && !formEl) return;

        let heroPassed = false;
        let formInView = false;

        const heroObs = new IntersectionObserver(([e]) => {
            heroPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
            setShow(heroPassed && !formInView);
        }, { threshold: 0 });

        const formObs = new IntersectionObserver(([e]) => {
            formInView = e.isIntersecting;
            setShow(heroPassed && !formInView);
        }, { threshold: 0.15 });

        if (heroSentinel) heroObs.observe(heroSentinel);
        if (formEl) formObs.observe(formEl);
        return () => { heroObs.disconnect(); formObs.disconnect(); };
    }, [onHome]);

    const click = () => {
        if (onHome) {
            document.querySelector("#enquiry-form")?.scrollIntoView({ behavior: "smooth" });
        } else {
            navigate("/#enquiry-form");
        }
    };

    if (!show) return null;

    return (
        <button
            onClick={click}
            className="md:hidden fixed left-3 right-3 z-30 bg-terracotta text-offwhite font-manrope font-bold text-[15px] py-3.5 rounded-md shadow-xl animate-slide-up"
            style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
            data-testid="mobile-sticky-cta"
        >
            Get Your Free Design
        </button>
    );
}
